import { temAcesso } from '@/shared/auth/temAcesso'
const Pagamentos = () => import('./Pagamentos.vue')
const Pagamento = () => import('./Pagamento.vue')

export default {
    path: 'pagamentos',
    name: 'Sgtec_Financeiro_Pagamentos',
    component: Pagamentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('SGTEC-UFI-PAG-00')) {
            next()
        }
    },
    children: [
        {
            path: ':pagamentoId',
            name: 'Sgtec_Financeiro_Pagamentos_Detalhar',
            component: Pagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('SGTEC-UFI-PAG-00')) {
                    next()
                }
            }
        }
    ]
}
